import type { ComponentPropsWithoutRef } from 'react';
import styles from './FilterButton.module.css';

interface FilterButtonProps extends Omit<ComponentPropsWithoutRef<'button'>, 'className'> {
  readonly isActive: boolean;
}

export function FilterButton({ isActive, children, ...props }: FilterButtonProps) {
  return (
    <button
      className={`${styles.filterButton} ${isActive ? styles.active : ''}`}
      type="button"
      {...props}
    >
      {children}
    </button>
  );
}
